import { QueryClient } from '@tanstack/react-query'

/** The app's TanStack Query client (defaults match cgt-frontend). */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}
